import { InfiniteScrollComponent } from './infinite-scroll.component';

export default angular
  .module('sfMobile.components.infinite-scroll', [
    'sfMobile.components.content',
  ])
  .component('sfInfiniteScroll', InfiniteScrollComponent).name;
